import { render, staticRenderFns } from "./check_results.vue?vue&type=template&id=03bb7c96&scoped=true"
import script from "./check_results.vue?vue&type=script&lang=js"
export * from "./check_results.vue?vue&type=script&lang=js"
import style0 from "./check_results.vue?vue&type=style&index=0&id=03bb7c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb7c96",
  null
  
)

export default component.exports